import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSelector } from 'react-redux';

import { VideaTextButton } from '../../common-components/elements/VideaButton/VideaButton';
import { FmxIcon } from '../../common-components/elements/VideaIcons/VideaIcons';
import { VideaTypography } from '../../common-components/elements/VideaTypography/VideaTypography';
import {
  blueBlack700,
  blueUltramarine050,
} from '../../theme/videa-style-tokens';
import { useRotation } from '../annotator/multiFileViewer/RotationContext';
import type { ImageObject } from '../annotator/types';
import { isDirectorUser } from '../login/login-utils';

import { ImageHistorySection } from './imageHistorySection/ImageHistorySection';

const ImageHistoryContainer = styled.div`
  width: 100%;
  padding: 0;
  margin: 0.5em 0 1em 0;

  .button-close {
    display: flex;
    align-items: center;
    gap: 0.5em;
    color: white;
    padding: 0.5em 1em;
    background-color: ${blueBlack700};
    margin: 0 0 0 2.5em;

    .icon-shape {
      fill: white;
    }
  }
`;

const ImagesContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface ImageHistoryProps {
  activeImage: ImageObject | null;
  showPastVisits: boolean;
  setShowPastVisits: (showPastVisits: boolean) => void;
}

export const ImageHistory = ({
  activeImage,
  showPastVisits,
  setShowPastVisits,
}: ImageHistoryProps) => {
  const { currentlyRotatingImages } = useRotation();
  const user = useSelector((state: any) => state.login?.user);
  const canEdit = !isDirectorUser(user);

  return (
    <ImageHistoryContainer >
      <VideaTextButton
        className="button-close"
        onClick={() => setShowPastVisits(!showPastVisits)}
      >
        <ArrowBackIcon /> <FmxIcon /> <Trans>Back to FMX</Trans>
      </VideaTextButton>
      {!!currentlyRotatingImages?.imageIds.length && canEdit && (
        <VideaTypography color={blueUltramarine050} variant="labelSmallStrong">
          <Trans>
            To rerun AI on rotated images (for most accurate results), please go
            back to the FMX view. You may access older visits using the top left
            dropdown menu.
          </Trans>
        </VideaTypography>
      )}
      <ImagesContainer>
        <ImageHistorySection section="left" activeImage={activeImage} />
        <ImageHistorySection section="right" activeImage={activeImage} />
      </ImagesContainer>
    </ImageHistoryContainer>
  );
};
